export function alignPlansBenefits() {
	setPlanCardsHeight();

	let debounceTimer;
	window.addEventListener('resize', () => {
		clearTimeout(debounceTimer);
		debounceTimer = setTimeout(() => {
			setPlanCardsHeight();
		}, 200);
	});
}

export function alignAdditionalBenefits() {
	alignAdditionalBenefitsGroups();

	let debounceTimer;
	const scheduleAlign = () => {
		clearTimeout(debounceTimer);
		debounceTimer = setTimeout(alignAdditionalBenefitsGroups, 150);
	};

	window.addEventListener('resize', scheduleAlign);
	document.addEventListener('plan-toggle:change', scheduleAlign);

	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(alignAdditionalBenefitsGroups);
	}
}

function alignAdditionalBenefitsGroups() {
	document.querySelectorAll('.plans').forEach(group => {
		const wraps = Array.from(group.querySelectorAll('.plan-benefits-additional-wrap'))
			.filter(el => el.offsetParent !== null);

		wraps.forEach(el => {
			el.style.setProperty('--align-offset', '0px');
			el.style.removeProperty('min-height');
		});

		if (wraps.length < 2) {
			return;
		}

		const maxHeight = Math.max(...wraps.map(el => el.offsetHeight));
		wraps.forEach(el => el.style.setProperty('min-height', `${maxHeight}px`));

		const tops = wraps.map(el => el.getBoundingClientRect().top);
		const maxTop = Math.max(...tops);

		wraps.forEach((el, index) => {
			const diff = Math.round(maxTop - tops[index]);
			if (diff > 0) {
				el.style.setProperty('--align-offset', `${diff}px`);
			}
		});
	});
}

function setPlanCardsHeight() {
	const planCards = document.querySelectorAll('.plans .plan');

	if (planCards) {
		let minHeight = 0;
		planCards.forEach(card => {
			const planHead = card.querySelector('.plan-head');
			const planHeadHeight = planHead ? planHead.offsetHeight : 0;

			if (planHeadHeight > minHeight) {
				minHeight = planHeadHeight;
			}
		});

		planCards.forEach(card => {
			const planHead = card.querySelector('.plan-head');
			if (planHead) {
				planHead.style.minHeight = `${minHeight}px`;
			}
		});
	}
}